import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@react/react-spectrum/Dialog';
import { withLocalization } from '@exc-ui/exc-sdk/dist/production/localization/withLocalization';
import './TermsOfUseDialog.css';
import { NOOP } from '../../constants/genericConstants';

/** Terms of Use dialog component */
class TermsOfUseDialog extends Component {
  static propTypes = {
    /** Experience Cloud Domain*/
    excDomian: PropTypes.string,
    /** Terms of Use page Link*/
    touHref: PropTypes.string,
    /** Localization Strings*/
    localizationStrings: PropTypes.shape({
      /** TOU Dialog Title*/
      touDialogTitle: PropTypes.string,
      /** Confirm Label toaccept the terms of use*/
      touDialogConfirmLabel: PropTypes.string,
      /** Refresh content label*/
      touDialogCancelLabel: PropTypes.string,
      /** Line-1 of the text to de displayed in the TOU dialog*/
      touTextLine1: PropTypes.string,
      /** Line-2a of the text to de displayed in the TOU dialog*/
      touTextLine2a: PropTypes.string,
      /** Experience Cloud*/
      experienceCloud: PropTypes.string,
      /** Line-2b of the text to de displayed in the TOU dialog*/
      touTextLine2b: PropTypes.string,
      /** Line-3 of the text to de displayed in the TOU dialog*/
      touTextLine3: PropTypes.string
    }),
    /** i18n FormattedMessage*/
    FormattedMessage: PropTypes.func.isRequired
  };

  static defaultProps = {
    excDomian: 'https://experiencecloud.adobe.com',
    touHref: '',
    localizationStrings: {
      touDialogTitle: 'Adobe Experience Cloud Terms of Use',
      touDialogConfirmLabel: 'Login & Accept Terms',
      touDialogCancelLabel: 'Refresh content',
      touTextLine1: 'Adobe Experience Cloud Terms of Use have been updated.',
      touTextLine2a: 'Please log into',
      experienceCloud: 'Experience Cloud',
      touTextLine2b: 'and accept the updated terms before proceeding.',
      touTextLine3: 'After accepting the terms, please click Refresh content.'
    },
    FormattedMessage: NOOP
  };

  state = {
    /** Boolean flag to disable/enable accept terms button*/
    loginAndAcceptDisabled: false
  };


  handleLoginAndAcceptTerms = () => {
    const { touHref } = this.props;

    if (touHref && touHref.trim().length > 0) {
      this.setState({ loginAndAcceptDisabled: true });
      window.open(touHref, '_blank');
    }
  };

  handleRefreshContent = () => {
    window.location.reload();
  };

  render() {
    const {
      excDomian,
      localizationStrings,
      FormattedMessage
    } = this.props;

    const {
      loginAndAcceptDisabled
    } = this.state;

    const i18nFM = FormattedMessage;

    return (
      <Dialog
        className="toubox"
        variant="confirmation"
        title={i18nFM({ messageId: 'touDialogTitle',
            defaultMessage: localizationStrings.touDialogTitle
          })}
        confirmLabel={i18nFM({ messageId: 'touDialogConfirmLabel',
            defaultMessage: localizationStrings.touDialogConfirmLabel
          })}
        cancelLabel={i18nFM({ messageId: 'touDialogCancelLabel',
            defaultMessage: localizationStrings.touDialogCancelLabel
          })}
        confirmDisabled={loginAndAcceptDisabled}
        onConfirm={this.handleLoginAndAcceptTerms}
        onCancel={this.handleRefreshContent}
      >
        <span>
        {i18nFM({ messageId: 'touTextLine1',
          defaultMessage: localizationStrings.touTextLine1
        })}
        {i18nFM({ messageId: 'touTextLine2a', defaultMessage: localizationStrings.touTextLine2a })}
        <a href= {excDomian} target='_blank'> {i18nFM({ messageId: 'experienceCloud', defaultMessage: localizationStrings.experienceCloud })}  </a>
        {i18nFM({ messageId: 'touTextLine2b', defaultMessage: localizationStrings.touTextLine2b })}
        {i18nFM({ messageId: 'touTextLine3', defaultMessage: localizationStrings.touTextLine3 })}
        </span>
      </Dialog>
    );
  }
};

export default withLocalization(TermsOfUseDialog);



// WEBPACK FOOTER //
// ./src/components/TermsOfUseDialog/TermsOfUseDialog.js